import { UserEnteredVehicle, addVehicleResponse, editUserVehicleParams, settingsReqParams, settingsUpdateResponse } from "./type_defs";

export const send_editVehicle = async (vehicleEdits:editUserVehicleParams) => {
	let success:boolean = false;
	let response:string;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/editVehicle",
		data:JSON.stringify(vehicleEdits),
		contentType: "application/json",
		dataType: "html",
		success: (data) => {
			response = data;
			success = true;
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};


export const submit_missingCampground = async (name:string, state:string, website:string|null, city:string|null) => {
	let errMsg:string;
	let success:boolean = false;

  await $.ajax({
		type: "post",
		url: "/submit_missingCampground",
		data: JSON.stringify({
			camp_name: name,
			camp_state: state,
			camp_url: website,
			camp_city: city
		}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			success = true;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};


export const send_addVehicle = async (vehicleInfo:UserEnteredVehicle) => {
	let success:boolean = false;
	let response:addVehicleResponse;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/addVehicle",
		data: JSON.stringify(vehicleInfo),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true;
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<addVehicleResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_deleteUserVehicle = async (vehicleID:string) => {
	let success:boolean = false;
	let response:addVehicleResponse;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/remUserVehicle",
		data: JSON.stringify({
			vehicleID:vehicleID
		}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true;
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<addVehicleResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const set_savedTrip_name = async (tripID:string, tripName:string) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./set_tname",
		data: JSON.stringify({tripID:tripID,tname:tripName}),
		contentType: "application/json",
		dataType: "text",
		success: function(data) {
			if (data === "success") success = true;
			else {
				success = false;
				errMsg = data;
			};
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};


export const set_savedTrip_description = async (tripID:string, tripDesc:string) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./set_tdesc",
		data: JSON.stringify({tripID:tripID,tdesc:tripDesc}),
		contentType: "application/json",
		dataType: "text",
		success: function(data) {
			if (data === "success") success = true;
			else {
				success = false;
				errMsg = data;
			}
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export const send_delete_trip = async (tripID:string) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type:"post",
		url:"/deleteSavedTrip",
		data:JSON.stringify({tripID:tripID}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			if (data == "success") success = true;
			else errMsg = data;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export const send_copyTrip = async (tripID:string, name:string, ownTrip:boolean, copyStays:boolean, copyNotes: boolean) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/copyTrip",
		data: JSON.stringify({
			tripID: tripID,
			name: name,
			ownTrip: ownTrip,
			copyNotes: copyNotes,
			copyStays: copyStays
		}),
		contentType: "application/json",
		success: () => { success = true; },
		error: (xhr,errStr,exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else (reject(Error(errMsg)));
	})
};

export const reverseGeocode = async (lat:number, lon:number) => {
	let success:boolean = false;
	let errMsg:string;
	let responseResult:string;

	await $.ajax({
		type:"get",
		url:`/reverseGeocode?lat=${lat}&lon=${lon}`,
		contentType: '',
		dataType: 'json',
		success: (data) => {
			responseResult = data.address;
			success = true;
		},
		error: (xhr,errStr,exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseResult);
		else reject(Error(errMsg));
	});
};

export const send_favoriteCamp = async (camp_id: number) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/favoriteCampsite",
		data: JSON.stringify({"camp_id":camp_id}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			if (data == "success") {
				success = true;
			} else {
				success = false;
				errMsg = data;
			};

			document.dispatchEvent(new CustomEvent("favoritedCamps.updated"));
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	})

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export const send_unfavoriteCamp = async (camp_id:number) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
        url: "/unfavoriteCampsite",
        data: JSON.stringify({camp_id:camp_id}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			if (data == "success") success = true;
			else {
				success = false;
				errMsg = data;
			};

			document.dispatchEvent(new CustomEvent("favoritedCamps.updated"));
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	})

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

/*
 * checks all settings on profile settings page to see which have changed since loading page
 * sends request to server to update any that have changed
 */
export const update_profile_settings = async (initial_vals: Array<string>, new_vals: Array<string>, labels: Array<string>) => {
	let success:boolean = false;
	let response:settingsUpdateResponse;
	let errMsg:string;

	let data:settingsReqParams = {
		"page": "profile",
		"data": {}
	};
	let i:number = 0;
	if (initial_vals.length != new_vals.length || initial_vals.length != labels.length) return;
	for (i = 0; i < new_vals.length; i++) {
		if (new_vals[i] != initial_vals[i]) {
			data.data[labels[i]] = new_vals[i];
		};
	};

	await $.ajax({
		type: "post",
		url: "./userSettings",
		data: JSON.stringify(data),
		contentType: "application/json",
		dataType: "json",
		success: function(data) {
			response = data;
			success = true;
		},
		error: function(req, errStr, exceptionObj) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<settingsUpdateResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};